import { useState, useEffect, useContext, createContext, useRef } from 'react';
import { createRoot, Link, Navigate, Outlet, Route, Routes, BrowserRouter, HashRouter, useParams, useLocation, useNavigate, } from 'react-router-dom';
import { AppContext, AppContextProvider } from './context'
import { webAuth, baseUrl, ui, live, apiUrl, client, mobile, audience, domain } from './delcare'
import UiInput1 from './ui_input1';
import UiButton1 from './ui_button1';
import UiSpinner from './ui_spinner';
import { useAuth0 } from '@auth0/auth0-react';


const Login = () => {

	const navigate = useNavigate()


	const { loginLoaded, hh, neonUser } = useContext(AppContext);
	const { loginWithRedirect, isAuthenticated, user, logout, isLoading } = useAuth0();

	const initLogin = () => {

		loginWithRedirect({
			authorizationParams: {
				audience: audience,
			},
			// ext: {
			// 	allow_remember_browser: true
			// }
		})
	}

	useEffect(() => {

		// console.log({ href: window.location.href })


		if (loginLoaded && !isLoading && !isAuthenticated) {
			if (window.location.href.includes('signup')) {
				loginWithRedirect({
					authorizationParams: {

						screen_hint: "signup",
						audience: audience
					},
					ext: {
						allow_remember_browser: true
					}
				})
				return
			}
			if (window.location.href.includes("email=")) {
				let email = window.location.href.match(/email=(.*)/g)
				// console.log({ email })
				if (email.length > 0) {
					email = email[0].split("=")[1]
					loginWithRedirect({
						authorizationParams: {
							login_hint: email,
							audience: audience
						},
						// ext: {
						// 	allow_remember_browser: true
						// }
					})
				}
			}

			// loginWithRedirect()

		}


	}, [loginLoaded, isLoading, isAuthenticated])



	return loginLoaded && !isLoading ? (

		// return !isAuthenticated ? (

		<div className="login-bg-2 w-100 d-flex flex-column justify-content-center py-4 px-2"  >

			<div className="d-flex justify-content-center mb-3">
				<div className="bispoke-logo align-self-center"></div>
			</div>
			<div style={{ height: hh }} className='w-100 '>


				<div className="bg-white shadow-lg login-container text-center" style={{ maxWidth: "450px", margin: "auto" }}>

					<div className='my-2 w-100 px-4'>
						<p className='mb-0 fs-4 poppins'>Welcome</p>
						<p className="poppins text-secondary">{user && user.name}</p>
						{isAuthenticated ?
							<div className='d-flex flex-column text-center gap-2'>
								<button className='btn btn-secondary' onClick={() => logout({
									logoutParams: {
										returnTo: window.location.origin + "/"
									}
								})}>Logout</button>

								<button className='btn btn-link' onClick={() => window.location.reload()}>My Account</button>
							</div>

							:
							<div className='d-flex flex-column gap-3'>
								<UiButton1 text="Log In" submit={initLogin} />

								{/* <UiButton1 text="Sign up" submit={() => loginWithRedirect({ authorizationParams: { screen_hint: "signup", audience: audience } })} /> */}

								<div
									onClick={() => loginWithRedirect({ authorizationParams: { screen_hint: "signup", audience: audience } })}
									className='button3 d-flex flex-column justify-content-center' style={{ height: 44, cursor: "pointer" }}>
									<span className='fs-6 poppins'>Sign Up</span>
								</div>
							</div>
						}
					</div>

				</div>


			</div>



		</div>
	)
		:
		<div className="d-flex justify-content-center" style={{ height: hh }}>
			<UiSpinner />
		</div>

}

export default Login